import { usePersistedQuery } from "@/features/order-sheet-sets/hooks/use-persisted-query";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import { useCallback } from "react";
import { NavigateOptions } from "react-router";
import { SheetTabFilterQuery } from "@/features/order-sheet-sets/sheet-tab-filter";

export interface LineSheetSetSelectQuery {
  lineSheetId?: number;
  lineSheetTabIndex?: number;
}

export interface LineSheetSetPagePersistedQuery
  extends LineSheetSetSelectQuery,
    SheetTabFilterQuery {
  referer: string;
}

export default function useLineSheetSetPagePersistedQuery() {
  const { value, set } = usePersistedQuery<LineSheetSetPagePersistedQuery>({
    entries: {
      referer: {
        parse: StringTransformer.parseString,
        stringify: StringTransformer.stringifyString,
      },
      lineSheetId: {
        parse: StringTransformer.parseId,
        stringify: StringTransformer.stringifyId,
      },
      lineSheetTabIndex: {
        parse: StringTransformer.parseId,
        stringify: StringTransformer.stringifyId,
      },
      brandName__eq: {
        parse: StringTransformer.parseStrings,
        stringify: StringTransformer.stringifyStrings,
      },
      brandId__in: {
        parse: StringTransformer.parseIds,
        // 표준 stringifyIds는 [undefined] 같은 corruption이 들어오면
        // String(undefined) = "undefined"를 URL에 넣어버린다. 여기서 한 번 더 필터링.
        stringify: (rawValue: number[] | undefined): string[] | undefined => {
          if (!rawValue) return undefined;
          const filtered = rawValue.filter(
            (n) => typeof n === "number" && Number.isFinite(n)
          );
          return filtered.length > 0 ? filtered.map((n) => String(n)) : undefined;
        },
      },
      gender__eq: {
        parse: StringTransformer.parseStrings,
        stringify: StringTransformer.stringifyStrings,
      },
      category__eq: {
        parse: StringTransformer.parseStrings,
        stringify: StringTransformer.stringifyStrings,
      },
      season__in: {
        parse: StringTransformer.parseStrings,
        stringify: StringTransformer.stringifyStrings,
      },
      quantity__gte: {
        parse: StringTransformer.parseId,
        stringify: StringTransformer.stringifyId,
      },
      query: {
        parse: StringTransformer.parseString,
        stringify: StringTransformer.stringifyString,
      },
      "madeByCompany.id__in": {
        parse: StringTransformer.parseIds,
        stringify: StringTransformer.stringifyIds,
      },
      orderBy: {
        parse: StringTransformer.parseString,
        stringify: StringTransformer.stringifyString,
      }
    },
  });

  return {
    value,
    set,
  };
}
